<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4 col-md-offset-4">
        <div class="login-panel panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Авторизация</h3>
          </div>
          <div class="panel-body">
            <p class="panel-body__text">
              Пожалуйста, {{ user.login }}, введите свой пароль для
              подтверждения личности
            </p>
            <form @submit.prevent="submitForm">
              <fieldset>
                <div class="form-group">
                  <input
                    class="form-control"
                    placeholder="Пароль"
                    name="password"
                    type="text"
                    v-model="password"
                    autofocus
                  />
                </div>
                <div class="panel-body__buttons">
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="backToTypes"
                    :disabled="isSuccess"
                  >
                    Вернуться обратно
                  </button>
                  <button
                    type="submit"
                    class="btn btn-success"
                    :disabled="submitWasDisabled"
                  >
                    Войти
                  </button>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useNotification } from "@/_shared/mixins";
import router from "@/_shared/router";
import apiService from "@/authorization/apiService";
export default {
  mixins: [useNotification],
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      password: "",
      isSuccess: false,
    };
  },
  computed: {
    submitWasDisabled() {
      return !!(this.password.length === 0 || this.isSuccess);
    },
  },
  methods: {
    backToTypes() {
      this.$emit("on-cancel");
    },
    async submitForm() {
      try {
        await apiService
          .login(this.user, this.password)
          .then((loggedToday) => {
            this.isSuccess = true;
            const message = `Добро пожаловать, ${this.user.login}!`;
            this.showSuccessNotification(message);
            setTimeout(() => {
              // if (loggedToday === false) {
              //   const notice = 'Не забудьте начать рабочую смену!';
              //   this.showStandardNotification(notice, 4000);
              // }
              router.push("/");
            }, 1500);
          })
          .catch(({ response }) => {
            throw new Error(response.data.message);
          });
      } catch (error) {
        this.showErrorNotification(error.message);
      }
    },
  },
};
</script>

<style scoped>
.panel-body__buttons {
  display: flex;
  justify-content: flex-end;
  column-gap: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/authorization/components/PasswordForm.vue